export const sumFloatNumbers = (a: number, b: number) => {
    let maxDecimalPlaces = 0;

    maxDecimalPlaces = Math.max(maxDecimalPlaces, String(a).split('.')[1]?.length || 0);
    maxDecimalPlaces = Math.max(maxDecimalPlaces, String(b).split('.')[1]?.length || 0);

    const factor = 10 ** maxDecimalPlaces;
    /*
     * 0.1 + 0.2 !== 0.3 IEEE 754
     */
    const scaledSum = Math.round(a * factor) + Math.round(b * factor);

    return scaledSum ? scaledSum / factor : scaledSum;
};
